import { flattenJson } from './src/flattenJson';

/**
 * Permite añadir cadenas traducidas al dictionario del idioma pasado en parametro.
 * Si no se pasa el `dictionary`, se devolvera un clone del dictionary. (para log solo)
 *
 * @param {Object} state El objeto global para recuperar `state.dictonary`
 * @param {string} localeId la locale (2 o 5 caracteres, ej. "es", "fr", "en-US", "pt-BR",...)
 * @param {Object} [dictionary] Objeto con las traducciones `{key: value, ...}`
 *
 * - options.type:
 * Por defecto, se espera un properties, ejemplo de properties:
 * { 'global.insertLine': 'insertar nueva linea' }
 * También se puede pasar un json, entonces hay que indicar `type = 'json';`, ejemplo de json:
 * {
 *   global: {
 *     insertLine: 'insertar nueva linea',
 *   }
 * }
 */

export function translations(state, localeId, dictionary) {
  if (typeof localeId !== 'string') {
    throw new Error(`"localeId" must be a string (with 2 caracters ej. "es", "fr", or 5 caracters ej. "en-US" o "pt-BR"... ).`);
  }

  state.dictionary = state?.dictionary ?? {};
  state.dictionary[localeId] = state.dictionary[localeId] ?? {};

  if (typeof dictionary === 'undefined') {
    return JSON.parse(JSON.stringify(state.dictionary[localeId]));
  }

  if (typeof dictionary !== 'object') {
    throw new Error(`"dictionary" must be an "object" {key: value} with values and not typeof "${typeof dictionary}". (loading "${localeId}")`);
  }

  const newFlattenDictionary = flattenJson(dictionary);

  Object.assign(state.dictionary[localeId], newFlattenDictionary);
}
